// ==========================================

function docMenuToggle(th) {
    let parent = th.closest('.has-sub-menu');

    parent.toggleClass('on');

    parent.children('.doc-sub-menu')
        .stop(true, true)
        .slideToggle(250);
}
$('.has-sub-menu > .scrollto').on('click', function () {
    docMenuToggle($(this));
});
$('.has-sub-menu .toggle').on('click', function () {
    docMenuToggle($(this));
});

// ==========================================

$(function () {
    function updateActiveMenu() {
        let scrollPos = $(window).scrollTop() + 150;
        let currentLink = null;
        $('.doc-menu a.scrollto').each(function () {
            let target = $($(this).attr('href'));
            if (!target.length) return;
            let top = target.offset().top - 120;
            let bottom = top + target.outerHeight();
            if (scrollPos >= top && scrollPos < bottom) {
                currentLink = $(this);
            }
        });
        if (!currentLink) return;
        $('.doc-menu li').removeClass('active');
        currentLink.parent('li').addClass('active');
        let parent = currentLink.closest('.has-sub-menu');
        if (parent.length) {

            $('.has-sub-menu')
                .not(parent)
                .removeClass('on')
                .children('.doc-sub-menu')
                .stop(true, true)
                .slideUp(200);

            parent
                .addClass('on')
                .children('.doc-sub-menu')
                .stop(true, true)
                .slideDown(200);
        }
    }
    updateActiveMenu();
    $(window).on('scroll', updateActiveMenu);

});

// ==========================================

$('.doc-menu a.scrollto').on('click', function (e) {
    let target = $($(this).attr('href'));
    if (target.length) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: target.offset().top - 120
        }, 10);
    }
});

// ==========================================

document.querySelectorAll('.image-popup').forEach(function (link) {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        let img = this.querySelector('img').src;
        document.getElementById('popupImage').src = img;
        document.getElementById('imagePopup').style.display = 'flex';
    });
});
document.querySelector('.close').onclick = function () {
    document.getElementById('imagePopup').style.display = 'none';
};

$('.shimcalc').submit(function () {
  var $inputs = $('.shimcalc :input');
  var values = {};
  $inputs.each(function () {
    values[this.name] = $(this).val();
  });

  var avgUpperRail = (parseFloat(values['mid']) + parseFloat(values['left']) + parseFloat(values['right'])) / 3;
  var nod = parseFloat(values['nod']);

  if (!isNaN(nod) && !isNaN(avgUpperRail)) {
    var shimThick = nod + avgUpperRail;
    var location = 'Lower';
    if (shimThick < 0) {
      location = 'Upper';
    }
    var shims = Math.round(Math.abs(shimThick / 0.00118));

    $('.shimresult').text(shims + ' shim(s) per bearing block surface required in the ' + location + ' position.');
  } else {
    $('.shimresult').text('Something went wrong- check your values!');
  }

  return false;
});